import '../Style/SectionLessWorry.css'
import online from '../Images/online.gif';
import check from '../Images/check.png'
import octopus from '../Images/octopus.png'
import rocket from '../Images/rocket.png'
import sun from '../Images/sun.png'
import trustworthiness from '../Images/trustworthiness.png'

function LessWorry() {
    return (
        <>
            <div className="container-fluid less-worry row  pt-5 pb-5 d-flex justify-content-center align-items-center m-0 ">
                
                <div className="content-less-worry text-center mb-4">
                    <h1 className="display-2 fw-bold">Less Worry, More Wonder</h1>
                    <p className="fw-bold">Parenting might not come with a manual, but it now comes with an app.</p>
                </div>

                <div className=" row container-fluid ">
                    <div className="text-content col-lg-6 col-sm-12 row  p-0">



                        <div className='col-lg-6 col-sm-12 mb-5'>
                            <div className='img-cu col-3 text-center'>
                                 <img src={ trustworthiness} alt='' className='p-2 ' style={{width:"60px", height:"auto"}} />
                            </div>
                         <h4 className='fw-bold pb-3' >Real-time parenting support (even at 3am)</h4>
                         <h5 >No more late-night Googling or going down an internet rabbit hole. Riley delivers instant, expert answers to all of your parenting questions – day or night.</h5>
                        </div>



                        <div className='col-lg-6 col-sm-12 mb-5 '>
                            <div className='img-cu col-3 text-center'>
                                 <img src={ octopus} alt='' className='p-2 ' style={{width:"60px", height:"auto"}} />
                            </div>
                            <h4 className='fw-bold pb-3' >When you need a solution, not a 10 hour course</h4>
                            <h5>From independent sleep to handling tantrums, the first five years keep you on your toes. Riley guides you every (baby) step of the way with custom plans made just for you.</h5>
                        </div>
                        <div className='col-lg-6 col-sm-12 mb-5'>
                            <div className='img-cu col-3 text-center'>
                                 <img src={ check} alt='' className='p-2 ' style={{width:"60px", height:"auto"}} />
                            </div>
                            <h4 className='fw-bold pb-3 ' >Your parenting toolbox, all in one place</h4>
                            <h5>Riley makes it easy to ask, track, and organize everything you need. Diapers, growth, vaccinations, milestones - all in one place.</h5>
                        </div>



                        <div className='col-lg-6 col-sm-12 mb-5'>
                            <div className='img-cu col-3 text-center'>
                                 <img src={ rocket} alt='' className='p-2 ' style={{width:"60px", height:"auto"}} />
                            </div>
                            <h4 className='fw-bold pb-3' >Personalized parenting, powered by you</h4>
                            <h5>Riley isn't just smart—it's uniquely yours. Riley learns and adapts based on your preferences and parenting style with advice that feels like it's from a trusted friend.   </h5>
                        </div>

                    </div>
                    <div className="image-content col-lg-6 col-sm-12 text-center p-0 pb-5">
                        <img src={online} alt="main" className="main-img" style={{width:"60%", height:"auto"}}/>
                    </div>
                </div>
            <div className='sun '><img src={sun} alt=''/></div>
            </div>
        </>
    )
}

export default LessWorry;
